import React, { type JSX, useMemo, useContext } from 'react';
import { ReactComponent as MinimizeIcon } from '@/assets/chevron-down.svg';
import { ReactComponent as CloseIcon } from '@/assets/close.svg';
import classNames from 'classnames';
import { styled } from '@mui/material/styles';
import {
	configContext,
	configurationContext,
	frameStateContext,
} from '../../../../contexts';

export const HeaderActions = styled(
	({
		className,
		isMobile,
		...props
	}: JSX.IntrinsicElements['div'] & {
		isMobile: boolean;
	}) => {
		const { toggler_button } = useContext(configurationContext);

		const { hidden } = toggler_button ?? {};

		const { survey: surveyEnabled } = useContext(configContext);
		const {
			toggleChat,
			page,
			togglePage,
			isStandalone,
			isOpen: { isOpen },
			isFullscreen,
		} = useContext(frameStateContext);

		const isMobileOpen = isMobile && isOpen;
		const isFullscreenOpen = isFullscreen && isOpen;
		const isHidden = hidden || isStandalone;
		const showMinimize = (isMobileOpen || isFullscreenOpen) && !isHidden;

		const onClose = useMemo(() => {
			if (page === 'messages' && surveyEnabled) {
				return () => togglePage('survey');
			}
			return undefined;
		}, [surveyEnabled, page, togglePage]);

		return (
			<div className={classNames('header__actions', className)} {...props}>
				<button
					type="button"
					className={classNames(
						'header__minimize',
						!showMinimize && 'header__minimize--hidden',
					)}
					onClick={() => toggleChat(false)}
				>
					<MinimizeIcon className="icon minimize" />
				</button>
				{onClose && (
					<button
						type="button"
						className="header__close"
						onClick={() => onClose()}
					>
						<CloseIcon className="icon close" />
					</button>
				)}
			</div>
		);
	},
	{ label: 'HeaderActions', target: 'HeaderActions-root' },
)({
	display: 'flex',
	height: 'calc(18px + 15px * 2)',
	marginLeft: 'auto',
	'& > button': {
		height: 'calc(18px + 15px * 2)',
	},
	'& .header__minimize': {
		width: 'calc(4px + 15px * 2)',
		'& .st0': {
			stroke: 'var(--chat__header__minimize_color)',
		},
		'&.header__minimize--hidden': {
			display: 'none',
		},
	},
	'& .header__close': {
		width: 'calc(4px + 15px * 2)',
		backgroundColor: 'transparent',
		border: 0,
		'& .close': {
			float: 'none',
		},
		'& svg': {
			width: '12px',
			height: '12px',
			stroke: 'var(--chat__header__close_border)',
			fill: 'var(--chat__header__close_color)',
		},
	},
});
